module.exports = __webpack_public_path__ + "media/eyezen-start_livre.ca1379bf.mp4";